import React from "react";
import { Dialog } from "@headlessui/react";

type props = {
  children?: React.ReactNode;
  className?: string;
  [key: string]: any;
  gridcol?: string;
};

export const FormBox = ({ children, className="" ,gridcol="sm:grid-cols-2"}: props) => {
  return (
    <div className={`text-left sm:grid sm:items-start sm:gap-4 sm:pt-5 ${className} ${gridcol}`}>
      {children}
    </div>
  );
};

export const ModalFoterBox = ({ children }: props) => {
  return (
    <div className="p-4 bg-gray-100">
      <div className="flex justify-end">{children}</div>
    </div>
  );
};

export const ModalHeaderBox = ({ title, Subtitle }: props) => {
  return (
    <Dialog.Title
      as="h3"
      className="text-left text-lg font-medium leading-6 text-gray-900"
    >
      <div>
        <h3 className="text-lg font-medium leading-6 text-gray-900">{title}</h3>
        <p className="mt-1 text-sm text-gray-500">{Subtitle}</p>
      </div>
    </Dialog.Title>
  );
};
